export default __webpack_public_path__ + "static/media/footer-back-black.d5ead173.png";